import React, {useState} from "react";
import GroupGamesListRowDetailsPlayer from "./GroupGamesListRowDetailsPlayer";
import GamesListRowVideos from "./GamesListRowVideos";
import * as UserService from "../../api/UserService";

function GroupGamesListRowDetails(props) {
    const [recordingStatus, setRecordingStatus] = useState(props.game.recording_status)

    function startVideoProcessing() {
        UserService.processGroupGameRecordings(props.game.id, () => {
            setRecordingStatus("processing")
        }, () => {})
    }

    return (
        <div style={{
            overflow: "auto"
        }}>
            <div style={{
                marginBottom: "18px"
            }}>
                {props.players?.map((player) => (
                    <GroupGamesListRowDetailsPlayer
                        key={player.id}
                        player={player}
                        gameId={props.game.id}
                    />
                ))}
            </div>

            {props.game.recording_status !== null && props.game.recording_status !== "allowed" &&
                <GamesListRowVideos recordingStatus={recordingStatus}
                                    startVideoProcessing={startVideoProcessing}
                                    mentorVideos={props.mentorVideos}
                                    playerVideos={props.playerVideos}></GamesListRowVideos>
            }

        </div>
    )
}

export default GroupGamesListRowDetails;